import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ALLOWED_MARKDOWN_ELEMENTS } from './markdownConstants';
import { CAI_CTA_PROTOCOL } from './markdownConstants';

interface MarkdownActionsProps {
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  allowedElements?: string[];
}

export type MarkdownProps = React.ComponentProps<typeof ReactMarkdown> & MarkdownActionsProps;

const Markdown = (props: MarkdownProps) => {
  const { onClick, allowedElements, components, remarkPlugins, unwrapDisallowed = true, ...rest } = props;
  const markdownPlugins = [remarkGfm, ...(remarkPlugins || [])];

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onClick?.(event);
  };

  const doURLTransform = (href: string) => {
    if (href.startsWith(CAI_CTA_PROTOCOL)) {
      return href;
    }

    // keeping this defaultUrlTransform for now to handle relative links
    // this hellps to prevent us from XSS attacks
    return defaultUrlTransform(href);
  };

  return (
    <ReactMarkdown
      {...rest}
      allowedElements={allowedElements || ALLOWED_MARKDOWN_ELEMENTS}
      components={{
        a: ({ href, children }) => (
          <a href={href} onClick={handleClick}>
            {children}
          </a>
        ),
        ...components,
      }}
      remarkPlugins={markdownPlugins}
      unwrapDisallowed={unwrapDisallowed}
      urlTransform={doURLTransform}
    />
  );
};

export default Markdown;
